export default __webpack_public_path__ + "static/media/amb1.b33f7668.jpg";